import { categories } from '@/mocks/yokaiManga';

export default function Categories() {
  return (
    <section id="categories" className="bg-paper-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 flex flex-col gap-2 md:mb-12">
          <p className="text-sm font-medium text-primary-600">按类型浏览</p>
          <h2 className="font-serif text-2xl font-bold text-ink-900 md:text-3xl">
            妖精类型分类
          </h2>
          <p className="max-w-2xl text-sm text-ink-500 md:text-base">
            狐妖、猫妖、花妖、树妖、雪女、河童……每个类型都是一座风格各异的宝藏库，
            点击即可进入对应的合集入口。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-6">
          {categories.map((cat) => (
            <article
              key={cat.id}
              className="group overflow-hidden rounded-2xl border border-paper-200 bg-paper-50 transition-all hover:-translate-y-1"
            >
              <div className="relative h-48 w-full overflow-hidden md:h-56">
                <img
                  src={cat.img}
                  alt={`${cat.name}漫画合集`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink-900/50 to-transparent"></div>
                <span className="absolute bottom-3 left-4 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-ink-900">
                  {cat.count} 部作品
                </span>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-50 text-lg text-primary-500">
                    <i className={cat.icon} aria-hidden="true"></i>
                  </span>
                  <h3 className="font-serif text-lg font-bold text-ink-900">{cat.name}漫画</h3>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-ink-500">{cat.desc}</p>
                <a
                  href="#collection"
                  className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
                >
                  查看{cat.name}合集
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}